module.exports = __webpack_public_path__ + "../static/img/logo.315ad7fa.svg";